export default __webpack_public_path__ + "static/media/beck-overlay.a6bf0105.png";